var OGENERAL_AR_RAJ1E = {
  name: "OGENERAL_AR_RAJ1E",
  defaultCommandIndex: 1,
  commands: [
    {
      mode: "AC_MODE_OFF",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_NULL",
      command: [115,0,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,231,243,36,146,68],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,62,127,255,255,255,255,255,156,146,121,16],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,60,159,255,255,255,255,255,231,36,146,72,132],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,63,63,255,255,255,255,255,156,146,100,136,64],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,60,207,255,255,255,255,255,231,36,147,34,16],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,62,79,255,255,255,255,255,231,36,156,136,64],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,62,79,255,255,255,255,255,231,36,156,136,64],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,63,159,255,255,255,255,255,156,146,102,33,0],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,60,231,255,255,255,255,255,231,36,147,136,64],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,62,103,255,255,255,255,255,231,36,158,33,0],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,60,153,255,255,255,255,255,249,201,36,146,68],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,63,39,255,255,255,255,255,231,36,153,36,64],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,60,201,255,255,255,255,255,249,201,36,201,16],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,62,73,255,255,255,255,255,249,201,39,36,64],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,62,127,243,255,255,255,255,231,146,121,16],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,60,159,252,255,255,255,255,249,228,146,72,132],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,63,63,243,255,255,255,255,231,146,100,136,64],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,60,207,252,255,255,255,255,249,228,147,34,16],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,62,79,252,255,255,255,255,249,228,156,136,64],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,60,147,255,63,255,255,255,254,121,36,152,132],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,63,159,243,255,255,255,255,231,146,102,33,0],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,60,231,252,255,255,255,255,249,228,147,136,64],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,62,103,252,255,255,255,255,249,228,158,33,0],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,60,153,255,63,255,255,255,254,121,36,146,68],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,63,39,252,255,255,255,255,249,228,153,36,64],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,60,201,255,63,255,255,255,254,121,36,201,16],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,62,73,255,63,255,255,255,254,121,39,36,64],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,62,127,249,255,255,255,255,231,50,121,16],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,60,159,254,127,255,255,255,249,204,146,72,132],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,63,63,249,255,255,255,255,231,50,100,136,64],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,60,207,254,127,255,255,255,249,204,147,34,16],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,62,79,254,127,255,255,255,249,204,156,136,64],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,60,147,255,159,255,255,255,254,115,36,152,132],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,63,159,249,255,255,255,255,231,50,102,33,0],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,60,231,254,127,255,255,255,249,204,147,136,64],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,62,103,254,127,255,255,255,249,204,158,33,0],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,60,153,255,159,255,255,255,254,115,36,146,68],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,63,39,254,127,255,255,255,249,204,153,36,64],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,60,201,255,159,255,255,255,254,115,36,201,16],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,62,73,255,159,255,255,255,254,115,39,36,64],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,62,127,242,127,255,255,255,249,242,121,16],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,60,159,252,159,255,255,255,254,124,146,72,132],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,63,63,242,127,255,255,255,249,242,100,136,64],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,60,207,252,159,255,255,255,254,124,147,34,16],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,62,79,252,159,255,255,255,254,124,156,136,64],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,60,147,255,39,255,255,255,255,159,36,152,132],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,63,159,242,127,255,255,255,249,242,102,33,0],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,60,231,252,159,255,255,255,254,124,147,136,64],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,62,103,252,159,255,255,255,254,124,158,33,0],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,60,153,255,39,255,255,255,255,159,36,146,68],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,63,39,252,159,255,255,255,254,124,153,36,64],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,60,201,255,39,255,255,255,255,159,36,201,16],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,62,73,255,39,255,255,255,255,159,39,36,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,62,115,255,255,255,255,255,231,146,121,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,60,156,255,255,255,255,255,249,228,146,72,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,63,51,255,255,255,255,255,231,146,100,136,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,60,204,255,255,255,255,255,249,228,147,34,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,62,76,255,255,255,255,255,249,228,156,136,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,60,147,63,255,255,255,255,254,121,36,152,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,63,147,255,255,255,255,255,231,146,102,33,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,60,228,255,255,255,255,255,249,228,147,136,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,62,100,255,255,255,255,255,249,228,158,33,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,60,153,63,255,255,255,255,254,121,36,146,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,63,36,255,255,255,255,255,249,228,153,36,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,60,201,63,255,255,255,255,254,121,36,201,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,62,73,63,255,255,255,255,254,121,39,36,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,62,115,252,255,255,255,255,249,204,158,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,60,156,255,63,255,255,255,254,115,36,146,33,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,63,51,252,255,255,255,255,249,204,153,34,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,60,204,255,63,255,255,255,254,115,36,200,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,62,76,255,63,255,255,255,254,115,39,34,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,60,147,63,207,255,255,255,255,156,201,38,33,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,63,147,252,255,255,255,255,249,204,153,136,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,60,228,255,63,255,255,255,254,115,36,226,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,62,100,255,63,255,255,255,254,115,39,136,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,60,153,63,207,255,255,255,255,156,201,36,145,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,63,36,255,63,255,255,255,254,115,38,73,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,60,201,63,207,255,255,255,255,156,201,50,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,62,73,63,207,255,255,255,255,156,201,201,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,62,115,254,127,255,255,255,249,242,121,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,60,156,255,159,255,255,255,254,124,146,72,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,63,51,254,127,255,255,255,249,242,100,136,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,60,204,255,159,255,255,255,254,124,147,34,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,62,76,255,159,255,255,255,254,124,156,136,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,60,147,63,231,255,255,255,255,159,36,152,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,63,147,254,127,255,255,255,249,242,102,33,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,60,228,255,159,255,255,255,254,124,147,136,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,62,100,255,159,255,255,255,254,124,158,33,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,60,153,63,231,255,255,255,255,159,36,146,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,63,36,255,159,255,255,255,254,124,153,36,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,60,201,63,231,255,255,255,255,159,36,201,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,62,73,63,231,255,255,255,255,159,39,36,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,62,115,252,159,255,255,255,254,114,103,145,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,60,156,255,39,255,255,255,255,156,153,36,136,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,63,51,252,159,255,255,255,254,114,102,72,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,60,204,255,39,255,255,255,255,156,153,50,33,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,62,76,255,39,255,255,255,255,156,153,200,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,60,147,63,201,255,255,255,255,231,38,73,136,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,63,147,252,159,255,255,255,254,114,102,98,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,60,228,255,39,255,255,255,255,156,153,56,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [3,1,  5,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 240,1,  120,1, 0,0,   115,60,158,79,255,207,243,228,146,73,57,255,39,62,100,255,39,255,255,255,255,156,153,226,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,60,153,63,201,255,255,255,255,231,38,73,36,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,63,36,255,39,255,255,255,255,156,153,146,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,60,201,63,201,255,255,255,255,231,38,76,145,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,62,73,63,201,255,255,255,255,231,38,114,68],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,62,73,39,242,127,255,255,255,249,206,114,68],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,62,73,39,249,255,255,255,255,231,153,201,16],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [3,1,  4,  120,1, 180,1,  10,13, 50,6,  120,1, 200,4,  120,1, 0,0,  115,60,158,79,255,207,243,228,146,73,57,255,39,62,73,39,243,255,255,255,255,231,38,114,68],
    },
    ]
};

export default OGENERAL_AR_RAJ1E
